import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {CesiumAdapterService} from "../cesiumAdapter21/cesium-adapter.service";
import {GOOGLE_SATELLITE_TILE_URL, GOOGLE_TILE_SUBDOMAINS} from "@src/configs/view_only";
import {EsBsModalService} from "@src/app/services/bsModalService/bs-modal.service";
import {ImageryProviderService} from "@src/app/services/imageryProvider/imagery-provider.service";

@Injectable({
  providedIn: 'root'
})
export class NearmapService {

  public _availableDates: BehaviorSubject<{}> = new BehaviorSubject<{}>({});
  private _selectedDate: BehaviorSubject<string> = new BehaviorSubject<string>('');
  set selectedDate(val){
    this._selectedDate.next(val);
  }
  public _tmpSelectedDate: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public _loadingDates: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public _isEnabled: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public tmpSelectedDate = '';

  public get loadingDates(): Observable<boolean> { return this._loadingDates.asObservable(); }
  public get availableDates(): Observable<{}> { return this._availableDates.asObservable(); }

  public availableDatesValue() { return this._availableDates.getValue(); }
  public getSelectedDateValue() { return this._selectedDate.getValue(); }

  protected tilingScheme = new Cesium.WebMercatorTilingScheme();
  protected dateCache = {};
  public TILE_SIZE = 256;

  public disabledByLimit = false;
  public usage = 0;

  public isEventKey = false;

  constructor(protected cesiumAdapterService: CesiumAdapterService, protected modalControl: EsBsModalService) {
    let localStorage = window.localStorage;
    if (localStorage) {
      let d = localStorage.getItem('customTile1Date');
      if (d) {
        this._selectedDate.next(localStorage.getItem('customTile1Date'));
      }
    }

    this.cesiumAdapterService.cameraEventMove.subscribe(() => {
      if (this._isEnabled.getValue()) {
        this.loadDates();
      }
    });

    this.cesiumAdapterService.setNearmapService(this);

    let self = this;

    if (window.hasOwnProperty('NEARMAP_IS_EVENT_KEY') && window['NEARMAP_IS_EVENT_KEY']) {
      this.isEventKey = window['NEARMAP_IS_EVENT_KEY'];
    }

    if (!this.isEventKey) {
      if (window.hasOwnProperty('NEARMAP_USAGE')) {
        this.usage += window['NEARMAP_USAGE'];
      }

      document.addEventListener('oneTileDownloaded', (e: CustomEvent) => {
        if (e.detail.type == 'nearmap') {
          self.usage += e.detail.size / (1024 * 1024);
          if (self.getUsagePercent() >= 100 && !self.disabledByLimit) {
            self.disabledByLimit = true;
            self.replaceProvider();
            self.modalControl.currentModal = '.nearmap-limit-modal';
            self.modalControl.openModal({backdrop: true, keyboard: false});
          }
        }
      });
    }
  }

  public updateImagery(e) {
    let date = e.target.options[e.target.selectedIndex].innerHTML;
    console.log('updateImagery', date, this._loadingDates.getValue());
    if (this._loadingDates.getValue()) { return; }
    this.tmpSelectedDate = date;
    this._selectedDate.next(this.tmpSelectedDate);
    let localStorage = window.localStorage;
    if (localStorage) {
      localStorage.setItem('customTile1Date', date);
    }
    this.cesiumAdapterService.redrawViewMode();
  }

  public setLoadDate(d){
    this._isEnabled.next(true);
    this.tmpSelectedDate = d;
    this._selectedDate.next(d);
    this.loadDates(()=>{
      console.log('redrawViewMode');
      this.cesiumAdapterService.redrawViewMode();
    });
  }

  public loadDates(cb?) {
    let $ = jQuery;
    let c = this.cesiumAdapterService.getMapCenter();
    let tile = this.tilingScheme.positionToTileXY(c, 15);
    let key = tile.x + '_' + tile.y;

    if (this.dateCache.hasOwnProperty(key)) {
      this._availableDates.next(this.dateCache[key]);
      this.tmpSelectedDate = this._selectedDate.getValue();
      if (cb){
        cb();
      }
    } else {
      this._loadingDates.next(true);
      this._availableDates.next({});

      if (this.cesiumAdapterService.hdMapRectangle && !Cesium.Rectangle.contains(this.cesiumAdapterService.hdMapRectangle, c)) {
        this._loadingDates.next(false);
      } else {
        $.ajax({
          url: '/index.php/custom-tile/custom-tiles-one-dates/' + window['EVENT_ID'] + '?x=' + tile.x + '&y=' + tile.y,
          dataType: 'json',
          success: (data) => {
            if (!this.dateCache.hasOwnProperty(key)) {
              this.dateCache[key] = data;
              this._availableDates.next(this.dateCache[key]);
              this.tmpSelectedDate = this._selectedDate.getValue();
              this._loadingDates.next(false);
              if (cb) {
                cb();
              }
            }
          }
        });
      }
    }
  }

  public replaceProvider() {
    this.cesiumAdapterService.viewer.imageryLayers.remove(this.cesiumAdapterService.imageryProviders['8'].layer);
    let defaultKey = this.cesiumAdapterService.getDefaultImageryProviderId();
    this.cesiumAdapterService.imageryProviders['8'].layer = new Cesium.ImageryLayer(
      this.cesiumAdapterService.imageryProviders[defaultKey].provider,
      { show: true }
    );
    this.cesiumAdapterService.viewer.imageryLayers.add(this.cesiumAdapterService.imageryProviders['8'].layer);
  }

  public enable() {
    this._isEnabled.next(true);
    this.loadDates();
    if (!this.isEventKey && this.getUsagePercent() == 100) {
      this.replaceProvider();
      this.modalControl.currentModal = '.nearmap-limit-modal';
      this.modalControl.openModal({backdrop: true, keyboard: false});
    }
  }

  public disable() {
    this._isEnabled.next(false);
  }

  public getLimitMb() {
    if (window.hasOwnProperty('NEARMAP_LIMIT')) {
      return window['NEARMAP_LIMIT'];
    }
    return 0;
  }



  public getUsageMb() {
    return this.usage;
    // let usage = 0;
    // if (window.hasOwnProperty('NEARMAP_USAGE')) {
    //   usage+= window['NEARMAP_USAGE'];
    // }
    // if (window.hasOwnProperty('NEARMAP_CURRENT_USAGE')) {
    //   usage+= window['NEARMAP_CURRENT_USAGE'] / (1024 * 1024);
    // }
    // return usage;
  }

  public getUsagePercent() {
    return Math.min(100, 100 * this.getUsageMb() / this.getLimitMb());
  }
}
